exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#flyte-dropzone[data-v-472e55eb]{min-height:300px}#flyte-add-files[data-v-472e55eb]{padding-top:130px}.dz-uploaded-file[data-v-472e55eb]{cursor:default}#flyte-add-more-files[data-v-472e55eb]{position:absolute;left:15px;top:16px}.progress-display[data-v-472e55eb]{position:absolute;left:15px;bottom:10px;width:calc(100% - 100px)}#flyte-recipient-keyword[data-v-472e55eb]{display:none;width:auto;height:20px;border:none}#flyte-recipient-keyword[data-v-472e55eb]:focus{background-color:#f8f9fa}", ""]);

// exports
